import {
  Button,
  Checkbox,
  Col,
  DatePicker,
  Form,
  Input,
  Modal,
  Row,
  Select,
  message,
} from "antd";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useState } from "react";
import { createOrderState } from "../../../api/orders";

const { Option } = Select;
const { TextArea } = Input;

export default function CreateState({ isVisible, setVisible, order, order_id }: any) {
  const queryClient = useQueryClient();
  const [isLast, setLast] = useState<boolean>(false);

  const [form] = Form.useForm();

  const { mutate, isLoading } = useMutation({
    mutationFn: createOrderState,
    onError: (error) => {
      message.error(`${error}`);
    },
    onSuccess: () => {
      message.success("Added Successfully");
      form.resetFields();
      queryClient.invalidateQueries({ queryKey: ["orders", order_id] });
      setVisible(false);
    },
  });

  const onSubmit = async () => {
    const { title, status, description, due_date } =
      await form.validateFields();
    const data = {
      title,
      status,
      description,
      due_date,
      is_last: isLast,
      order_id: order?.id
    };

    mutate({ order_id: order?.id, data });
  };

  return (
    <Modal
      title="Add State"
      open={isVisible}
      onCancel={() => setVisible(false)}
      footer={[
        <Button key="back" onClick={() => setVisible(false)}>
          Cancel
        </Button>,
        <Button
          key="submit"
          form="addOrderState"
          htmlType="submit"
          onSubmit={onSubmit}
          loading={isLoading}
          className="border-0 bg-blue-600 text-white"
        >
          Submit
        </Button>,
      ]}
    >
      <Form
        id="addOrderState"
        form={form}
        name="control-ref"
        onFinish={onSubmit}
        layout="vertical"
      >
        <Row gutter={[16, 0]}>
          <Col xs={{ span: 24 }} lg={{ span: 24 }}>
            <Form.Item
              name="title"
              label="Title"
              rules={[
                {
                  required: true,
                  message: "Please enter title",
                },
              ]}
            >
              <Input placeholder="Title" />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={[16, 0]}>
          <Col xs={{ span: 24 }} lg={{ span: 12 }}>
            <Form.Item
              name="due_date"
              label="Due Date"
              rules={[
                {
                  required: false,
                  message: "Please enter due date",
                },
              ]}
            >
              <DatePicker placeholder="Due date" style={{ width: "100%" }} />
            </Form.Item>
          </Col>
          <Col xs={{ span: 24 }} lg={{ span: 12 }}>
            <Form.Item
              name="status"
              label="Status"
              initialValue={"Pending"}
              rules={[
                {
                  required: false,
                  message: "Please enter status",
                },
              ]}
            >
              <Select placeholder="Status" defaultValue={"Pending"}>
                <Option value="Pending">Pending</Option>
                <Option value="Inprogress">Inprogress</Option>
                <Option value="Completed">Completed</Option>
              </Select>
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={[16, 0]}>
          <Col xs={{ span: 24 }} lg={{ span: 24 }}>
            <Form.Item
              name="description"
              label="Description"
              rules={[
                {
                  required: false,
                  message: "Please enter description",
                },
              ]}
            >
              <TextArea placeholder="Description" />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={[16, 0]}>
          <Col xs={{ span: 24 }} lg={{ span: 12 }}>
            <Checkbox defaultChecked={isLast} onChange={() => setLast(!isLast)}>
              Is Last
            </Checkbox>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
}
